export const en = {
    "k_9fbdbc0a": "Whether to allow the data source interface to be called through the \"MCP Proxy\"",
    "k_54b43f9c": "MCP Agent Management",
    "k_e63b073": "MCP proxy key",
    "k_ca8ded0b": "Custom MCP Domain (Taihu)",
    "k_14a8fd6f": "Generating SKILL",
    "k_acb9c6b9": "Usage scenarios",
    "k_2ecf2c41": "Failed to obtain MCP Key list: {arg_0}",
    "k_b88b2726": "Please fill in the usage scenario",
    "k_14af6211": "The application was successful. Jumping to the approval process details page...",
    "k_2090abdf": "Application failed: {arg_0}",
    "k_9aed9623": "Copy failed",
    "k_4c0c49a6": "Deactivated",
    "k_b29acb15": "Apply for a new MCP Key",
    "k_b5d96930": "Please describe the usage scenario of MCP Key",
    "k_c0e51e12": "Apply for MCPKey",
    "k_94158804": "Applications need to be approved by the project manager",
    "k_50c61f18": "MCPKey"
};
